import React from 'react';
import {BONUS_TYPE_ENUM, POLICY_CONDITION_MODEL} from '../Model/Model';
import CustomDayPreview from "../../../../../../../../components/CustomDayPreview";
import {IconClockTable, IconScheduleTable} from "../../../../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, getDateFormat, getTimeFormat} from "../../../../../../../../Apis/functions";
import {convertToDate} from "../../../../../../../../utils/TimeConversion";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const ScopeCell = ({ rule, t }) => {
    if (rule.condition === POLICY_CONDITION_MODEL.WEEKLY_RECURRENCE.key) {
        return  <div className={"h-64px d-flex align-items-center"}>
            <div>
                <CustomDayPreview dayArray={rule.dayArray} setDayArray={() => {}}/>
                <div className={"d-flex align-items-center fs-12px"}>
                    <div><IconClockTable className={"mr-8px mb-1 icon-color-general-950"} /></div>

                    <CustomTooltip
                        text={`${getTimeFormat(convertToDate(rule.startTime))} ${t("to").toLowerCase()} ${getTimeFormat(convertToDate(rule.endTime))}`}
                        classes={"fs-14px font-color-general-950 text-ellipsis-1-row"}
                        showIfTruncated={true}
                        placement={"top"}
                    />
                </div>
            </div>
        </div>;
    }

    if (rule.condition === POLICY_CONDITION_MODEL.DATE_RANGE.key) {
        const maxValue = rule.startDate === rule.endDate ? '' : `${t("to").toLowerCase()} ${getDateFormat(rule.endDate, false)}`;
        return <div className={"d-flex align-items-center minw-100px h-64px"}>
                <div><IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} /></div>
                <CustomTooltip
                    text={`${getDateFormat(rule.startDate, false)} ${maxValue}`}
                    classes={"fs-14px font-color-general-950 text-ellipsis-1-row"}
                    showIfTruncated={true}
                    placement={"top"}
                />
            </div>;
    }

    if (rule.condition === POLICY_CONDITION_MODEL.HOUR.key) {
        const maxValue = rule.minValue === rule.maxValue ? '' : `${t("to").toLowerCase()} ${rule.maxValue}${t("h")}`;

        return   <div className={"d-flex align-items-center minw-100px h-64px"}>
            <div><IconClockTable className={"mr-8px mb-1 icon-color-general-950"} /></div>
            <CustomTooltip
                text={`${rule.minValue}${t("h")} ${maxValue}`}
                classes={"fs-14px font-color-general-950 text-ellipsis-1-row"}
                showIfTruncated={true}
                placement={"top"}
            />
        </div>;
    }

    if (rule.condition === POLICY_CONDITION_MODEL.BONUS.key) {
        const bonusType = BONUS_TYPE_ENUM[rule.bonusType];
        const Icon = bonusType?.Icon;

        return <div className={"d-flex align-items-center minw-100px h-64px"}>
            {Icon && <div><Icon className={"mr-8px mb-1 icon-color-general-950"} /></div>}
            <CustomTooltip
                text={`${rule.value}${bonusType?.prefixText} ${t(bonusType?.trans).toLowerCase()}`}
                classes={"fs-14px font-color-general-950 text-ellipsis-1-row"}
                showIfTruncated={true}
                placement={"top"}
            />
        </div>;
    }

    return EMPTY_VALUES.DEFAULT;
};

export default ScopeCell;
